import './InfoBar.css'; // create this CSS file

const InfoBar = ({ text }) => {
  return (
    <div className="w-full border font-semibold border-border bg-card text-text text-xl p-1 mb-3 mt-[1px] overflow-hidden relative">
      <div className="marquee">
        <span>{text}</span>
        <span>{text}</span> {/* duplicate for continuous scrolling */}
      </div>
    </div>
  );
};

export default InfoBar;
